<template>
	<div class="header">
		<div class="warp">
			<div class="logo pointer" @click="pageTo('/')">
				<img src="@/assets/logo-top.png" />
				<p>探索未来科技·用心做好车</p>
			</div>
			<ul class="nav">

				<li :class="{on:type=='/'}" @click="pageTo('/')">首页</li>
				<li :class="{on:type=='goodsList'}" @click="pageTo('goodsList')">产品中心</li>
				<span class="s1" @click="pageTo('auth')" v-if="userinfo.is_attestation==0">未认证</span>
				<span class="s3" @click="pageTo('auth')" v-if="userinfo.is_attestation==1"><img src="@/assets/qy.png"
						alt="" /> 个人</span>
				<span class="s3" @click="pageTo('auth')" v-if="userinfo.is_attestation==2"><img src="@/assets/qy.png"
						alt="" />企业</span>
				<el-dropdown @command="handleCommand">
					<li :class="{on:type=='user'}" style="padding:0 35px 0 10px;">
						<span>{{userinfo&&userinfo.nickname}}</span>
						<i class="el-icon-arrow-down"></i>
					</li>
					<el-dropdown-menu slot="dropdown">
						<el-dropdown-item command="user">个人中心</el-dropdown-item>
						<el-dropdown-item command="out">退出</el-dropdown-item>
					</el-dropdown-menu>
				</el-dropdown>
				<span class="s2">|</span>
				<li :class="{on:type=='orderList'}" @click="pageTo('orderList')">我的订单</li>
				<li :class="{on:type=='car'}" @click="pageTo('cart')" style="padding: 0;">购物车</li>
			</ul>
		</div>
	</div>
</template>

<script>
	import {
		mapState
	} from 'vuex'
	export default {
		name: 'hekHeader',
		props: {
			type: {
				type: String,
				default: '/'
			}
		},
		data() {
			return {

			};
		},
		created() {
			if (localStorage.getItem('token')) {

				this.getUserInfo()
			}


		},
		computed: {
			...mapState(['userinfo'])
		},
		methods: {
			getUserInfo() {
				this.$http.get('/api/user/index', {
					params: {

					}

				}).then(res => {
					console.log(res, 5555555)
					let user = res.data.user
					let nickname = res.data.user.nickname
					localStorage.setItem('nickname', nickname);
					localStorage.setItem('userinfo', JSON.stringify(res.data.user));
					this.$store.dispatch('setUserInfo', res.data.user);
				});
			},
			handleCommand(command) {
				// this.$message('click on item ' + command);
				if (command == 'user') {
					this.pageTo(command)
				} else {
					this.$confirm('退出登录, 是否继续?', '提示', {
						confirmButtonText: '确定',
						cancelButtonText: '取消',
						type: 'warning'
					}).then(() => {
						localStorage.clear()
						this.$store.dispatch('clearUserInfo')
						this.$store.dispatch('clearCartNumber')
						this.$message({
							type: 'success',
							message: '退出成功!'
						});
						setTimeout(() => {
							this.$router.push({
								path: '/login',
							});
						}, 2000)
					}).catch(() => {
						this.$message({
							type: 'info',
							message: '已取消'
						});
					});
				}
			},
			pageTo(url) {
				this.$router.push({
					path: url,
				});
			},

		},
	};
</script>
<style lang="less" scoped>
	@color: #FF6A00;
	@color2: #11192D;

	.header {
		background-color: #fff;
		width: 100%;
		position: fixed;
		top: 0;
		left: 0;
		right: 0;
		height: 80px;
		z-index: 999;
		border-bottom: 1px solid #eee;

		.warp {
			width: 1200px;
			margin: 0 auto;
			height: 80px;
			display: flex;
			align-items: center;
			justify-content: space-between;

			.logo {
				display: flex;
				align-items: center;

				img {
					width: 200px;
					height: 20px;
				}

				p {
					margin-left: 20px;
					color: #11192D;
					font-size: 14px;
					font-weight: 600;
				}
			}

			.nav {
				display: flex;
				align-items: center;
				justify-content: flex-end;

				li {
					padding: 0 25px;
					font-size: 14px;
					color: @color2;
					cursor: pointer;

					i {
						margin-left: 5px;
					}

					&:hover {
						color: @color;
					}
				}

				.on {
					color: @color;
				}

				.s1 {
					cursor: pointer;
					color: #fff;
					font-size: 12px;
					border-radius: 10px;
					height: 20px;
					line-height: 20px;
					display: inline-block;
					background: #A9A9A9;
					width: 50px;
					text-align: center;
					margin-left: 15px;
				}

				.s3 {
					cursor: pointer;
					color: @color;
					font-size: 12px;
					border-radius: 10px;
					height: 20px;
					line-height: 20px;
					display: inline-block;
					background: #FFF5EE;
					width: 50px;
					text-align: center;
					display: flex;
					align-items: center;

					img {
						width: 16px;
						height: 16px;
						margin-right: 5px;
					}
				}

				.s2 {
					padding: 0 5px 0 0;
					position: relative;
					display: block;
					width: 2px;
					color: #eee;
				}
			}
		}
	}
</style>